import { APIClient } from '@frontend/api-utils';

export class SlotActuatorClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async openSlot(accountId: string, spotId: string, moduleId: string, slotId: string, body: { iot_id?: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/slots/${slotId}/open`, body);
        return await this.handleVoidResponse(response);
    }
}
